import React from 'react';
import { observer } from 'mobx-react-lite';
import { Row, Col } from '@thd-olt-component-react/core-ui';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { generateImageSource } from '../../utils/generateImageSource';
import { JOB_POSTING_STATUS } from '../../utils/constants';
import { useStore } from '../../store';
import JobPostingNotification from '../../pages/JobPostings/JobPostingPage/JobPostingDetails/JobPostingNotification';

const CandidateViewUrl = () => {
  const { jobPostingStore: { copyUrlNotificationVisible, showCopyUrlNotificationVisible, activeJobPosting } } = useStore();

  function whenCopied() {
    navigator.clipboard.writeText(activeJobPosting.sharingUrl);
    showCopyUrlNotificationVisible();
  }

  const infoText = 'To view and apply to jobs, candidates use a third party platform, Worksuite. Use the links below to view your job posting on this platform or copy and share your job posting link with potential applicants.';

  if (activeJobPosting.status !== JOB_POSTING_STATUS.ACTIVE || activeJobPosting.shared === false) {
    return <></>;
  }

  return (
    <Row>
      <Col>
        <div className="ptp-job-posting__candidate-view-section">
          <p className="ptp-job-posting__candidate-view-info">
            View and share what your job looks like to candidates.
            <Tooltip channel="desktop" content={infoText} className="ptp-job-posting__tool-tip">
              <img
                src={generateImageSource('/images/v1/info.svg')}
                className="ptp-job-posting__info-icon"
              />
            </Tooltip>
          </p>
          <div className="ptp-job-posting__visibility-icon-wrapper">
            <VisibilityIcon className="MuiSvgIcon-root" />
            <a
              data-testid="preview-job-posting-url"
              href={activeJobPosting.sharingUrl}
              target="_blank"
              rel="noreferrer"
              className="ptp-job-posting__candidate-view-text"
            >
              Preview Job Posting
            </a>
          </div>
          <div className="ptp-job-posting__visibility-icon-wrapper">
            <img
              src={generateImageSource('/images/v1/path-to-pro/content_copy_icon.svg')}
              className="ptp-job-posting__visibility-icon-wrapper__content-copy-icon"
            />
            <button
              data-testid="copy-job-posting-url"
              onClick={() => whenCopied()}
              className="ptp-job-posting__candidate-view-text"
            >
              Copy Job Posting Link
            </button>
            <JobPostingNotification
              visible={copyUrlNotificationVisible}
              title="Link Copied to Clipboard"
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default observer(CandidateViewUrl);
